import { LoggerFactory } from '../logger';

const LOGGER = LoggerFactory.getLogger('activity');

export default LOGGER;
